<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="container">
    <!--添加工作室成员概况模块-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">工作室概况</div>
        <div class="title-desc">工作室整体每日的收益及互动数据</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">数据维度 </span>
          <span class="btnGroup">
            <!-- 拥有收入查看权限 -->
            <el-radio-group v-model="overviewType">
              <el-radio label="1" border size="medium" v-if="permission">
                收益</el-radio
              >
              <el-radio label="2" border size="medium">互动</el-radio>
            </el-radio-group>
            <!-- 无收入查看权限 -->
            <!-- <el-radio-group v-model="overviewType" v-else>
              <el-radio label="1" border size="medium">互动</el-radio>
            </el-radio-group> -->
          </span>
        </div>
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <span class="btnGroup">
            <el-date-picker
              v-model="studioDate"
              type="daterange"
              align="left"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              :picker-options="pickerOptions"
              @change="studioDateChange"
            >
            </el-date-picker>
            <el-button
              @click="handleSDateBtnClicked"
              class="search_btn"
              type="info"
              >查找</el-button
            >
          </span>
          <span class="download-wrap" v-if="overviewType === '1'">
            <!-- <img src="@/assets/images/icon_export.png" /> -->
            <!-- <span class="download-content">{{ downloadContent }}</span> -->
            <el-button
              class="download-content"
              type="primary"
              v-if="downloadBle === 0"
              @click="JudgExport"
              >导出数据</el-button
            >
            <el-button
              class="download-content"
              type="primary"
              v-else-if="downloadBle === 1"
              disabled
              >报表生成中</el-button
            >
            <el-button
              class="download-content"
              type="primary"
              v-else
              @click="fetchInExport"
              >下载数据</el-button
            >
          </span>
          <span class="download-wrap" @click="exportFn" v-else>
            <!-- <img src="@/assets/images/icon_export.png" /> -->
            <!-- <span class="download-content">{{ downloadContent }}</span> -->

            <el-button class="download-content" type="primary"
              >导出数据
            </el-button>
          </span>
        </div>
        <div class="data-table" v-loading="studioDataLoading">
          <!--收益数据-->
          <el-table :data="studioData" stripe v-if="overviewType === '1'">
            <el-table-column
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
              v-for="(item, index) in studioColData"
              :key="index"
            >
            </el-table-column>
          </el-table>
          <!--互动数据-->
          <el-table :data="studioVData" stripe v-else>
            <el-table-column
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
              v-for="(item, index) in studioViewColData"
              :key="index"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page" v-if="overviewType === '1'">
          <el-pagination
            background
            layout="prev,pager,next,jumper"
            :total="studioDataPageCount"
            @current-change="sDPaginationChange"
          >
          </el-pagination>
        </div>
        <div class="data-filter-page" v-else>
          <el-pagination
            background
            layout="prev,pager,next,jumper"
            :total="studioVDataPageCount"
            @current-change="oDPaginationChange"
          >
          </el-pagination>
        </div>
        <!--导出数据确定-->
        <el-dialog
          :visible.sync="judgeBle"
          width="668px"
          :show-close="false"
          class="dialog"
          title="数据导出确定"
        >
          <div class="dialog-wrap">
            <div class="content">
              您是否要导出 【{{ date1 | routeDate }}~{{ date2 | routeDate }}】
              范围内的工作室收益数据？
              <div class="content-hr">报表生成，点击下载后可以继续导出数据</div>
            </div>

            <div class="submit-wrap">
              <div class="submit1" @click="cancel">取消</div>
              <div class="submit2" @click="clickDownload">确定</div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudioOverview,
  getStudioDayIncomeData,
  exportStudioOverview,
  exportStudioIncome,
  getPermiss,
} from '@/api/studio';
import { mapState } from 'vuex';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      studioDataLoading: false,
      studioPagination: {
        page_size: 10,
        page: 1,
      },
      studioVPagination: {
        page_size: 10,
        page: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      studioDate: '',
      incomeType: '1',
      overviewType: '1',
      lastStudioDate: [],
      downloadContent: '导出数据',
      judgeBle: false,
      date1: 0,
      date2: 0,
      exportDate: {},
      studioData: [],
      permission: false,
      studioVData: [],
      position: 0,
      studioDataPageCount: 0,
      studioVDataPageCount: 0,
      studioColData: [
        {
          align: 'center',
          prop: 'date',
          label: '日期',
          classname: 'tb-date',
        },
        {
          align: 'center',
          prop: 'ad_count',
          label: '广告播放次数',
          classname: 'tb-ad_count',
        },
        {
          align: 'center',
          prop: 'ad_income',
          label: '广告收益',
          classname: 'tb-ad_income',
        },
        {
          align: 'center',
          prop: 'minipoint',
          label: '迷你点数量',
          classname: 'tb-minipoint',
        },
        {
          align: 'center',
          prop: 'contribution',
          label: '贡献点数量',
          classname: 'tb-contribution',
        },
        {
          align: 'center',
          prop: 'minibean',
          label: '迷你豆',
          classname: 'tb-minibean',
        },
      ],
      studioViewColData: [
        {
          align: 'center',
          prop: 'date',
          label: '日期',
          classname: 'tb-date',
        },
        {
          align: 'center',
          prop: 'new_map_count',
          label: '新增地图数',
          classname: 'tb-new_map_count',
        },
        {
          align: 'center',
          prop: 'download',
          label: '地图总下载数',
          classname: 'tb-download',
        },
        {
          align: 'center',
          prop: 'play_count',
          label: '游玩次数',
          classname: 'tb-play_count',
        },
        {
          align: 'center',
          prop: 'play_time',
          label: '游玩时长',
          classname: 'tb-play_time',
        },
        {
          align: 'center',
          prop: 'comment',
          label: '评论',
          classname: 'tb-comment',
        },
        {
          align: 'center',
          prop: 'collect',
          label: '收藏',
          classname: 'tb-collect',
        },
      ],
    };
  },
  created() {
    console.log('created----');
    // if (!this.permission) {
    //   this.overviewType = '2';
    // }
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    // const currTime = Date.now()
    this.studioDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  mounted() {
    console.log('mounted---');
    this.init();
    //概况-互动数据
    this.getOverviewData();
    //概况-收益
    this.getStudioDayIncome();
    this.getPerssion();
  },
  computed: {
    ...mapState(['downloadBle']),
  },
  filters: {
    MemberTypeFilter(type) {
      return type ? '签约成员' : '普通成员';
    },
    routeDate(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      return year + '-' + month + '-' + day;
    },
  },
  methods: {
    init() {
      //记录当前下载数据状态-----0：导出数据 1： 数据生成中  2.下载文件
      let downloadBle = JSON.parse(sessionStorage.getItem('downloadBle'));
      if (downloadBle === 0 || downloadBle === 1 || downloadBle === 2) {
        this.$store.commit('SET_DOWNLOADBLE', downloadBle);
      }
    },
    //概况表点击搜索
    handleSDateBtnClicked() {
      if (this.studioDate) {
        if (this.overviewType === '2') {
          this.getOverviewData();
        } else {
          this.getStudioDayIncome();
        }
      }
    },
    //判断是否导出数据
    JudgExport() {
      if (this.studioDate) {
        this.date1 = parseInt(this.studioDate[0], 10);
        this.date2 = parseInt(this.studioDate[1] + ONE_DAY_TIME, 10);
        this.judgeBle = true;
      } else {
        this.$message.error('请选择时间');
      }
    },
    cancel() {
      this.judgeBle = false;
    },
    clickDownload() {
      this.judgeBle = false;
      this.InexportFn();
    },
    //判断是否有收入查看权限
    async getPerssion() {
      let res = await getPermiss({ json: 1 });
      this.position = res.data.position;
      if (res.data.v1m_income == 1 || this.position == 1) {
        this.permission = true;
      } else {
        this.permission = false;
      }
      if (!this.permission) {
        this.overviewType = '2';
      }
    },
    //互动数据下载
    exportFn() {
      this.fetchExport();
      // console.log('---**'+this.overviewType)
    },
    InexportFn() {
      //导出详细数据埋点
      if (this.overviewType === 1) {
        this.$log('export_data_click', 85443, { v7: 1, v8: 1 });
      } else {
        this.$log('export_data_click', 85443, { v7: 1, v8: 2 });
      }
      //导出数据提示
      this.getInExport();
    },
    //导出数据提示
    async getInExport() {
      let data = {
        start_time: parseInt(this.studioDate[0] / 1000, 10),
        end_time: parseInt((this.studioDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      //记录导出数据的时间
      sessionStorage.setItem('exportDate', JSON.stringify(data));
      let res;
      //先判断30s是否生成url，生成则直接下载数据，否认则扭转装为报表生成中
      setTimeout(() => {
        //console.log('----已经过30s，判断是否生成url---');
        if (res) {
          // this.downloadBle = 0;
          this.$store.commit('SET_DOWNLOADBLE', 0);
          // sessionStorage.setItem('downloadBle', 0);
          this.downloadFile(res.data.url);
          this.$message.success('下载成功');
          //console.log('----以生成url，直接下载数据---');
        } else {
          //扭转状态为数据生成中
          //console.log('----url未生成，扭转状态为报表生成中---');
          setTimeout(() => {
            //console.log('----扭转状态为下载文件，下载url---');
            this.$store.commit('SET_DOWNLOADBLE', 2);
          }, 330000);
        }
      }, 30000); //30000
      this.$store.commit('SET_DOWNLOADBLE', 1);
      res = await exportStudioIncome(data);
    },
    //下载收益数据url
    async fetchInExport() {
      let data = JSON.parse(sessionStorage.getItem('exportDate'));
      try {
        const res = await exportStudioIncome({
          start_time: data.start_time,
          end_time: data.end_time,
        });
        //流程重新开始
        this.$store.commit('SET_DOWNLOADBLE', 0);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    //导出互动数据
    async fetchExport() {
      let data = {
        start_time: parseInt(this.studioDate[0] / 1000, 10),
        end_time: parseInt((this.studioDate[1] + ONE_DAY_TIME) / 1000, 10),
        json: 1,
      };
      try {
        const res = await exportStudioOverview(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    //下载工作室概况-互动表
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    toastMessage() {
      this.$message.error('仅能查看签约成员数据哦');
    },
    studioDateChange() {
      //console.log('studioDateChange', this.studioDate);
    },
    //概况-互动表分页
    oDPaginationChange(currPage) {
      this.studioVPagination.page = currPage;
      this.getOverviewData();
    },
    //收益表分页
    sDPaginationChange(currPage) {
      this.studioPagination.page = currPage;
      this.getStudioDayIncome();
    },
    //工作室概况表-收益
    async getStudioDayIncome() {
      this.studioDataLoading = true;
      this.lastStudioDate = this.studioDate;
      const res = await getStudioDayIncomeData(
        Object.assign(this.studioPagination, {
          start_time: parseInt(this.studioDate[0] / 1000, 10),
          end_time: parseInt((this.studioDate[1] + ONE_DAY_TIME) / 1000, 10),
        }),
      );
      this.studioDataLoading = false;
      console.log(Date.now());
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.studioData = list.map(item => {
            item.ad_income = Number(item.ad_income).toFixed(2);
            item.contribution = Number(item.contribution).toFixed(3);
            return item;
          });
        }
        this.studioDataPageCount = res.data.total_count;
      }
    },
    //工作室概况表获取互动数据
    async getOverviewData() {
      this.studioDataLoading = true;
      this.lastStudioDate = this.studioDate;
      const res = await getStudioOverview(
        Object.assign(this.studioVPagination, {
          start_time: parseInt(this.studioDate[0] / 1000, 10),
          end_time: parseInt((this.studioDate[1] + ONE_DAY_TIME) / 1000, 10),
          json: 1,
        }),
      );
      this.studioDataLoading = false;
      console.log(Date.now());
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.studioVData = list.map(item => {
            item.play_time = Number(item.play_time / 60).toFixed(2);
            return item;
          });
        }
        this.studioVDataPageCount = parseInt(res.data.total_count, 10);
      }
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .data-table {
    margin-top: 28px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
  }
  ::v-deep .el-button--text {
    color: #2b6ddf;
  }
  ::v-deep .el-date-editor.el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-range-editor.el-input__inner {
    padding: 3px 0;
  }
  ::v-deep .el-date-editor .el-range__icon {
    display: none;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 30px;
    color: #bfbfbf;
  }
  ::v-deep .el-dialog__header {
    text-align: center;
    font-size: 24px;
    color: #262626;
    padding-top: 40px;
  }
  ::v-deep .el-dialog__body {
    padding-top: 20px;
    .dialog-wrap {
      .content {
        font-size: 16px;
        text-align: center;
        color: #262626;
        .content-hr {
          margin-top: 10px;
        }
      }
      .submit-wrap {
        margin-top: 90px;
        padding-bottom: 40px;
        display: flex;
        justify-content: center;
        .submit1 {
          background: #d9d9d9;
          border-radius: 8px;
          color: #ffffff;
          font-size: 20px;
          margin-right: 70px;
          cursor: pointer;
          padding: 10px 40px 8px 40px;
        }
        .submit2 {
          background: #fd9b21;
          border-radius: 8px;
          color: #ffffff;
          cursor: pointer;
          font-size: 20px;
          padding: 10px 40px 8px 40px;
        }
      }
    }
  }
  .search_btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    color: #595959;
    border-right: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background-color: #f4f4f5;
  }
  .download-wrap {
    float: right;
    border-radius: 4px;
    font-size: 11px;
    // font-weight: 600;
    margin-top: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #2b6ddf;
    .download-content {
      padding: 10px 12px;
      //border: 1px solid #fd9b21;
      border-radius: 4px;
    }
    .el-button--primary.is-disabled {
      background: #d9d9d9;
      border: none;
    }
    img {
      margin-right: 8px;
    }
  }
  .all-look {
    color: #2b6ddf;
    text-decoration: underline;
    display: flex;
    justify-content: center;
  }
}
</style>
